import { supabase } from './supabase.js';

const DEDUPE_MS = 4000;
let lastFingerprint = '';
let lastFingerprintAt = 0;

function fingerprint(tipo, mensaje, pagina) {
  return `${tipo}|${String(mensaje || '').slice(0, 240)}|${String(pagina || '').slice(0, 120)}`;
}

/**
 * Errores típicos de extensiones del navegador (no enviar a backend).
 */
export function isLikelyBrowserExtensionError({ message, filename, source } = {}) {
  const combined = `${message ?? ''} ${filename ?? ''} ${source ?? ''}`;
  if (
    /chrome-extension:\/\/|moz-extension:\/\/|safari-web-extension:\/\/|blob:chrome-extension|webkit-masked-url:\/\/|extension:\/\//i.test(
      combined,
    )
  ) {
    return true;
  }
  if (/connect\.facebook\.net|googletagmanager\.com|google-analytics\.com|doubleclick\.net|hotjar\.com|clarity\.ms/i.test(combined)) {
    return true;
  }
  return false;
}

/**
 * Invoca la Edge Function `report-error` (JWT opcional para asociar user_id).
 */
export async function invokeReportError(payload) {
  const { data, error } = await supabase.functions.invoke('report-error', {
    body: payload,
  });
  if (error) throw error;
  if (data && data.error) {
    const msg = typeof data.message === 'string' ? data.message : data.error;
    throw new Error(msg);
  }
  return data;
}

/**
 * Igual que invokeReportError pero deduplica ráfagas del mismo error (captura global).
 */
export function reportErrorFireAndForget(payload, { dedupe = false } = {}) {
  if (dedupe) {
    const fp = fingerprint(payload.tipo, payload.mensaje, payload.pagina);
    const now = Date.now();
    if (fp === lastFingerprint && now - lastFingerprintAt < DEDUPE_MS) return;
    lastFingerprint = fp;
    lastFingerprintAt = now;
  }
  void invokeReportError(payload).catch(() => {});
}
